import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authenticationReducer } from '../app/auth/authReducer';
import { authErrorReducer } from '../app/auth/authErrorReducer';
import { AdminListReducer } from './admin-list/reducer';
import { campaignCreateReducer } from './campaign-create/reducer';
import { campaignListingAllReducer } from './campaign-listing/reducer';
import { campaignProfileReducer } from './campaign-profile/reducer';
import { canvasBuilderReducer } from './customer-journey/reducer';
import { emailJourneyCreateReducer } from './email-journey/reducer';
import { notificationReducer } from './notification/reducer';
import { constantStateReducer } from './constant-state/reducer';
import { CalenderReducer } from './calender/reducer';
import TeamReducer from './team/reducer';
import GenericMailsReducer from './generic-mails/reducer';
import { campaignKpisReducer } from './campaign-kpis/reducers';
import { SwitchReducer } from './switch-editor/reducer';
import { projectTypesReducer } from './project/reducer';
import { campaignStepCompletionReducer } from './campaign-step-completion/reducers';

// new Redux Store items
import stepStatuses from '../new-store/step-statuses/reducer.ts';
import adminCampaignList from '../new-store/admin-nodes-list/reducer.ts';
import userCampaignList from '../new-store/user-campaign-list/reducer.ts';
import therapeuticReducer from '../new-store/therapeutics/reducer.ts';
import productReducer from '../new-store/products/reducer.ts';
import templateReducer from '../new-store/templates/reducer.ts';
import adminListViewReducer from '../new-store/admin-list-view/reducer';
import targetingReducer from '../new-store/targeting/reducer';
import lightViewReducer from '../new-store/light-view/reducer';
import featuresReducer from '../new-store/features/reducer';
import cloneCampaignReducer from '../new-store/clone-campaign/reducer';
import stepFormReducer from '../new-store/step-forms/reducer';
import topBarReducer from '../new-store/top-bar/reducer';
import campaignsTimelineReducer from '../new-store/campaigns-timeline/reducer';
import childCampaignsReducer from '../new-store/child-campaigns/reducer';
import annualCampaignMapsReducer from '../new-store/annual-campaign-maps/reducer';
import impersonationReducer from '../new-store/impersonation/reducer.ts';
import { configureStore } from '@reduxjs/toolkit';
import { setStore } from './store-accessor';

const persistConfig = {
  key: 'orchestra',
  storage,
  whitelist: ['authentication'],
};

const reducers = combineReducers({
  adminCampaignList,
  customerJourneyBuilder: canvasBuilderReducer,
  campaignCreate: campaignCreateReducer,
  campaignListingAll: campaignListingAllReducer,
  emailJourneyCreate: emailJourneyCreateReducer,
  notification: notificationReducer,
  campaignProfile: campaignProfileReducer,
  adminList: AdminListReducer,
  authentication: authenticationReducer,
  authError: authErrorReducer,
  constantState: constantStateReducer,
  calenderView: CalenderReducer,
  team: TeamReducer,
  genericMails: GenericMailsReducer,
  campaignKpis: campaignKpisReducer,
  switch: SwitchReducer,
  projectTypes: projectTypesReducer,
  campaignStepCompletion: campaignStepCompletionReducer,
  stepStatuses,
  userCampaignList,
  therapeutics: therapeuticReducer,
  products: productReducer,
  templates: templateReducer,
  adminListView: adminListViewReducer,
  targeting: targetingReducer,
  lightView: lightViewReducer,
  features: featuresReducer,
  cloneCampaign: cloneCampaignReducer,
  stepForm: stepFormReducer,
  topBar: topBarReducer,
  timeline: campaignsTimelineReducer,
  childCampaigns: childCampaignsReducer,
  annualCampaignMaps: annualCampaignMapsReducer,
  impersonation: impersonationReducer,
});

const rootReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: rootReducer
});

setStore(store);

export default store;
